// Estúdio Social — catálogo de plataformas suportadas (espelha
// SUPPORTED_PLATFORMS em Api::V1::Accounts::Social::AccountsController).
//
// Direção visual (Task 10, vale para as Tasks 11-13): o badge de cada
// plataforma é o ÚNICO lugar do módulo com cor de marca saturada — o resto
// da tela usa só os tokens n-*. `badgeClass` usa cor de marca real via
// utilitário arbitrário do Tailwind (ex.: bg-[#1877F2]); `iconTone` só é
// definido quando o branco padrão não tem contraste (Snapchat = amarelo).
export const SOCIAL_PLATFORMS = [
  {
    key: 'instagram',
    icon: 'i-ri-instagram-fill',
    // Único gradiente do módulo — a marca mais reconhecível pela cor.
    badgeClass: 'bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]',
  },
  {
    key: 'facebook',
    icon: 'i-ri-facebook-fill',
    badgeClass: 'bg-[#1877F2]',
  },
  {
    key: 'tiktok',
    icon: 'i-ri-tiktok-fill',
    badgeClass: 'bg-[#000000]',
  },
  {
    key: 'linkedin',
    icon: 'i-ri-linkedin-fill',
    badgeClass: 'bg-[#0A66C2]',
  },
  {
    key: 'youtube',
    icon: 'i-ri-youtube-fill',
    badgeClass: 'bg-[#FF0000]',
  },
  {
    key: 'twitter',
    icon: 'i-ri-twitter-x-fill',
    badgeClass: 'bg-[#0F1419]',
  },
  {
    key: 'threads',
    icon: 'i-ri-threads-fill',
    badgeClass: 'bg-[#000000]',
  },
  {
    key: 'pinterest',
    icon: 'i-ri-pinterest-fill',
    badgeClass: 'bg-[#E60023]',
  },
  {
    key: 'reddit',
    icon: 'i-ri-reddit-fill',
    badgeClass: 'bg-[#FF4500]',
  },
  {
    key: 'bluesky',
    icon: 'i-ri-bluesky-fill',
    badgeClass: 'bg-[#1185FE]',
  },
  {
    key: 'discord',
    icon: 'i-ri-discord-fill',
    badgeClass: 'bg-[#5865F2]',
  },
  {
    key: 'slack',
    icon: 'i-ri-slack-fill',
    badgeClass: 'bg-[#4A154B]',
  },
  {
    key: 'googlebusiness',
    icon: 'i-ri-google-fill',
    badgeClass: 'bg-[#4285F4]',
  },
];
